import moment from 'moment';
import store from '@/store';

export default {
  install(Vue) {
    const phoneFormats = {
      us: /^(\d{3})(\d{3})(\d{4})$/, // (999) 999-9999
      ca: /^(\d{3})(\d{3})(\d{4})$/, // (999) 999-9999
      au: /^(\d{2})(\d{4})(\d{4})$/, // 99 9999 9999
    };

    // Vue[name] = app;
    Vue.appService = {
    };

    /**
     * Format phone number based on country code
     */
    Vue.filter('formatPhone', (phone) => {
      if (!phone) {
        return '';
      }
      const { country } = store.getters.locale;
      const phoneFormatted = phone.toString().replace(/\D/g, '');

      const match = phoneFormatted.match(phoneFormats[country]);
      if (match) {
        if (country === 'us') {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        if (country === 'ca') {
          return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        if (country === 'au') {
          return `${match[1]} ${match[2]} ${match[3]}`;
        }
      }

      return '';
    });

    /**
     * Format phone number based on country code
     */
    Vue.filter('formatCurrency', (amount) => {
      if (!amount) {
        return '';
      }
      const amountFormatted = parseFloat(amount).toFixed(2);
      return `$${amountFormatted}`;
    });

    /**
     * Format a date
     */
    Vue.filter('formatDate', (date) => {
      if (!date) {
        return '';
      }

      return moment(date).format('DD-MMM-YYYY');
    });

    /**
     * Simple pluralize
     */
    Vue.filter('pluralize', (number, suffix = 's') => {
      return parseInt(number, 10) === 1 ? '' : suffix;
    });
  },
};
